import * as React from 'react';

import DataConnector from 'connect/DataConnector';
import {Storable} from 'constants/SampleConstants';
import {Tag} from 'folder-items/FileConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {requestFetchManagedModel} from 'models/ManagedModelUtil';
import StorableSummaryExtrasManager from 'models/managers/StorableSummaryExtrasManager';
import StorableStore from 'samples/StorableStore';
import * as ExpandedTableTagUtil from 'schemas/tags/ExpandedTableTagUtil';
import {ScrollableTableColumn} from 'ui-library/scrollable/ScrollableTableConstants';
import APIUtil from 'util/APIUtil';

interface Props {
  storable: Storable;
  column: ScrollableTableColumn;
}
interface EnhancedProps {
  contentTags: Array<Tag>;
}

class StorableTagValueConnector extends DataConnector<Props, EnhancedProps> {
  stores = [StorableStore];

  enhanceProps(): EnhancedProps {
    const storableId = this.props.storable.id;
    StorableSummaryExtrasManager.requestFetch(storableId);
    const storableSummaryExtras = this.storableStore().getStorableSummaryExtras();
    const containableSummaries = storableSummaryExtras.containedItemsByContainerId
      ? storableSummaryExtras.containedItemsByContainerId[storableId]
      : [];
    const contentTags: Array<Tag> = containableSummaries
      ? containableSummaries.flatMap((summary) => {
          if (APIUtil.isBatch(summary.id)) {
            const batch = this.getOrFetchOptional(ManagedModelType.BATCH, summary.id);
            return batch ? batch.file.tags : [];
          } else {
            requestFetchManagedModel(ManagedModelType.BIOENTITY_SUMMARY, summary.id);
            const bioentity = this.reduxState().models.fileSummariesById[summary.id];
            return bioentity ? bioentity.tags : [];
          }
        })
      : [];

    return {
      contentTags,
    };
  }
}

class StorableTagValue extends React.Component<Props & EnhancedProps> {
  render(): JSX.Element {
    const tagsByColumn = ExpandedTableTagUtil.mapTagsToColumns({
      tags: [...this.props.storable.tags, ...this.props.contentTags],
      tagColumns: [this.props.column],
    });
    return tagsByColumn.tagFields[this.props.column.accessorKey];
  }
}

export default StorableTagValueConnector.connect(StorableTagValue);
